import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { Link, LinkProps } from '@unlikelystudio/react-abstract-components'
import {
  DeviceType,
  useDeviceType,
  useIsHover,
} from '@unlikelystudio/react-hooks'

import Cta from '~/components/Abstracts/Cta'
import Image, { ImageProps } from '~/components/UI/Image'
import InlineCta from '~/components/UI/InlineCta'

import { useStyle } from '~/providers/StyleProvider'

import { CTA } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type GridListCardProps = {
  className?: string
  hasReadMore?: boolean
  link?: LinkProps
  title?: string
  subtitle?: string
  image?: ImageProps
}

const IMAGE_SIZES = [{ layout: 'md', ratio: 3 / 24 }, { ratio: 5 / 16 }]

function GridListCard({
  className,
  hasReadMore,
  link,
  title,
  subtitle,
  image,
}: GridListCardProps) {
  const [isHovered, callbacks] = useIsHover()
  const device = useDeviceType()
  const t = useTranslate()
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title20SangBleuLight,
  })
  const subtitleStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Grotesk,
  })

  const isHovering = device === DeviceType.mobile ? false : isHovered

  return (
    <Link {...link} {...callbacks} className={cx(css.GridListCard, className)}>
      {image && (
        <Image
          className={css.image}
          sizesFromBreakpoints={IMAGE_SIZES}
          ratio={css.ratio}
          layout="fill"
          objectFit="cover"
          asPlaceholder
          {...image}
        />
      )}
      {(title || subtitle) && (
        <div className={css.content}>
          {title && <h4 className={cx(css.title, titleStyle)}>{title}</h4>}
          {subtitle && (
            <p className={cx(css.subtitle, subtitleStyle)}>{subtitle}</p>
          )}
          {hasReadMore && (
            <InlineCta
              textPreset={GlobalTextPreset.Cta10Grotesk}
              textStyling={GlobalTextStyling.UpperCase}
              lineProps={{
                initialLineState: isHovering ? 'none' : 'underlined',
                isVisible: !isHovering,
              }}
              className={css.cta}>
              {t(CTA.READ_MORE)}
            </InlineCta>
          )}
        </div>
      )}
    </Link>
  )
}

GridListCard.defaultProps = {}

export default GridListCard
